/*********************** Custom JS for Boost AI Search & Discovery  ************************/
console.log('Boost');